import { render, staticRenderFns } from "./FormTextField.vue?vue&type=template&id=e56964a6&"
import script from "./FormTextField.vue?vue&type=script&lang=ts&"
export * from "./FormTextField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports